import { AxiosRequestConfig, AxiosResponse } from 'axios'

const _api_ = process.env.REACT_APP_API_URL
const _kvkKey_ = process.env.REACT_APP_KVK_API_KEY

const apiConfig: AxiosRequestConfig = {
  baseURL: _api_,
  timeout: 1000 * 60,
  maxContentLength: 10000,
  responseType: 'json',
  responseEncoding: 'utf8',
  headers: {
    Accept: 'application/json',
    'Access-Control-Allow-Origin': '*',
    'content-type': 'application/json',
  },
  transformRequest: [
    (data: AxiosResponse['data']): AxiosResponse['data'] => {
      // Token is now added in the request interceptor in _base.api.ts
      return JSON.stringify(data)
    },
  ],
}

const KVKConfig: AxiosRequestConfig = {
  baseURL: 'https://ssltest.kvk.nl',
  headers: {
    apikey: 'l7xx1f2691f2520d487b902f4e0b57a0b197',
    accept: 'application/hal+json',
  },
  transformRequest: [
    (data: AxiosResponse['data']): AxiosResponse['data'] => {
      console.log('KVK: ', _kvkKey_)
      return JSON.stringify(data)
    },
  ],
}

const downloadConfig: AxiosRequestConfig = {
  baseURL: _api_,
  timeout: 1000 * 60,
  responseType: 'blob',
  transformRequest: [
    (data: AxiosResponse['data']): AxiosResponse['data'] => {
      // Token is now added in the request interceptor in _base.api.ts
      return data
    },
  ],
}

const uploadConfig: AxiosRequestConfig = {
  baseURL: _api_,
  timeout: 1000 * 60,
  maxContentLength: 10000,
  responseType: 'json',
  responseEncoding: 'utf8',
  headers: {
    'Content-Type': 'multipart/form-data',
    Accept: 'application/json',
    type: 'formData',
  },
  transformRequest: [
    (data: AxiosResponse['data']): AxiosResponse['data'] => {
      // Token is now added in the request interceptor in _base.api.ts
      return data
    },
  ],
}

export default {
  api: apiConfig,
  download: downloadConfig,
  upload: uploadConfig,
  kvk: KVKConfig,
}
